import { Component, Input } from '@angular/core';
import { Margin } from '@freelancer/ui/margin';
import { FontColor, FontWeight, TextSize } from '@freelancer/ui/text';

@Component({
  selector: 'app-user-profile-summary-reputation-item',
  template: `
    <fl-bit
      *ngIf="!loading"
      class="ReputationItem"
      [flMarginBottom]="Margin.XSMALL"
    >
      <fl-text
        class="ReputationItemAmount"
        [color]="FontColor.SUCCESS"
        [flMarginRight]="Margin.XSMALL"
        [size]="TextSize.XSMALL"
        [sizeTablet]="TextSize.SMALL"
        [weight]="FontWeight.BOLD"
      >
        <ng-container *ngIf="value">
          <ng-container *ngIf="percent; else plainValue">
            {{ value | percent: '1.0-0' }}
          </ng-container>
          <ng-template #plainValue>
            {{ value }}
          </ng-template>
        </ng-container>
        <ng-container *ngIf="!value" i18n="User's rating is not available">
          N/A
        </ng-container>
      </fl-text>

      <fl-text [size]="TextSize.XXSMALL" [sizeTablet]="TextSize.SMALL">
        {{ label }}
      </fl-text>
    </fl-bit>

    <fl-bit
      *ngIf="loading"
      class="ReputationItem"
      [flMarginBottom]="Margin.XSMALL"
    >
      <fl-text class="ReputationItemLoading">
        <fl-loading-text [height]="10" [padded]="false"></fl-loading-text>
      </fl-text>
    </fl-bit>
  `,
  styleUrls: ['./user-profile-summary-reputation-item.component.scss'],
})
export class UserProfileSummaryReputationItemComponent {
  FontColor = FontColor;
  TextSize = TextSize;
  FontWeight = FontWeight;
  Margin = Margin;

  @Input() value: number;
  @Input() loading: boolean;
  @Input() percent = true;
  @Input() label: string;
}
